import { Actions } from "vuex-smart-module";

import MapState from "./state";
import MapMutations from "./mutations";
import MapGetters from "./getters";
import { MutationTypes } from "../mutations-types";

export default class MapActions extends Actions<
  MapState,
  MapGetters,
  MapMutations,
  MapActions
> {
  activateMeasurement() {
    this.commit(MutationTypes.ACTIVATE_MEASUREMENT);
    if (!this.state.measurementActivated) {
      this.commit(MutationTypes.CLEAR_MEASUREMENT);
    } 
  }
}
